import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";


export default function CareerPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
            <Helmet>
                <title>Career - Equibre</title>
                <meta name="description" content="Join our team to enjoy innovative & diverse work culture. We are always commited to provide values to our team members for their expertise." />
            </Helmet>
            <section className="page-header-section">
                <div className="inner">
                    <h1>Career</h1>
                    <p>Join our team to enjoy innovative & diverse work culture. We are always commited to provide values to our team members for their expertise.</p>
                </div>
            </section>
            <section className="roles-section">
                <div className="inner">
                    <h1>There are no open roles at the present. Leave us your details and we will reach to you when we need you.</h1>
                    <a href="#" className="normal-link">WRITE US ABOUT YOU ↗</a>
                </div>
            </section>
            <section className="career-section">
                <div className="inner">
                    <div className="card-col">
                        <div className="card-row">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>We celebrate diversity and inclusivity, welcoming team members from all backgrounds, races, and classes. Your unique perspective is valued here.</h1>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>WORK & CULTURE</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-row">
                            <div className="inner">
                                <div className="card-hdr">
                                    <div className="col">
                                        <h1>Our culture is shaped by diverse experiences and a commitment to mutual growth and respect. We value your expertise and are dedicated to supporting your professional journey.</h1>
                                    </div>
                                </div>
                                <div className="card-label">
                                    <p>WHY WORK WITH US?</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ContactListSection />
        </>
    );
}